import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const fetcher = (path) => () => api.get(path).then((r) => r.data);

export function SiteProvider({ children }) {
  const settings = useQuery({ queryKey: ["settings"], queryFn: fetcher("/settings") });
  const rooms = useQuery({ queryKey: ["rooms"], queryFn: fetcher("/rooms") });
  const articles = useQuery({ queryKey: ["articles"], queryFn: fetcher("/articles") });
  const boats = useQuery({ queryKey: ["boats"], queryFn: fetcher("/boats") });
  const reviews = useQuery({ queryKey: ["reviews"], queryFn: fetcher("/reviews") });

  const value = {
    settings: settings.data,
    rooms: rooms.data || [],
    articles: articles.data || [],
    boats: boats.data,
    reviews: reviews.data || [],
  };
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export const waLink = (settings, text) => {
  const num = (settings?.whatsapp || "6281339192688").replace(/[^0-9]/g, "");
  const msg = encodeURIComponent(text || settings?.whatsapp_message || "Hello Mahadinusa Lembongan");
  return `https://wa.me/${num}?text=${msg}`;
};

// Builds the Alaric/Armella booking URL; when stay dates are chosen they are
// appended as checkin/checkout/adults which the booking engine reads on load.
export const bookingUrl = (settings, stay) => {
  const base = settings?.booking_url || "https://booking.armellabali.com/en/offers?hotel=MADN";
  if (!stay?.checkin) return base;
  const inDate = new Date(`${stay.checkin}T00:00:00`);
  if (isNaN(inDate.getTime())) return base;
  const outDate = new Date(inDate);
  outDate.setDate(outDate.getDate() + Math.max(1, Number(stay.nights) || 1));
  const iso = (d) => d.toISOString().slice(0, 10);
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}checkin=${iso(inDate)}&checkout=${iso(outDate)}&adults=${Math.max(1, Number(stay.guests) || 2)}`;
};
